<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <div class="container">
      <backtovorspeise></backtovorspeise>
    </div>
    <v-card>
      <v-card-title class="display-3">
        Suppen
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="desserts" :search="search" :items-per-page="-1">
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
import Backtovorspeise from './Backtovorspeise.vue';
export default {
  components: {
    Backtovorspeise,
  },
  name: 'Suppen',
  data() {
    return{
      items: [
        {
          src: require('../assets/images/misosuppemithintergrund.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/pikantesuppemithintergrund.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 1,
          speise: 'Miso Suppe',
          allergene: '(A, F)',
          preis: '2,90 €',
        },
        {
          nummer: 2,
          speise: 'Gemüsesuppe',
          allergene: '(A, F)',
          preis: '2,90 €',
        },
        {
          nummer: 3,
          speise: 'Suppe mit Meeresfrüchten',
          allergene: '(A, F, R)',
          preis: '3,70 €',
        },
        {
          nummer: 4,
          speise: 'Wan-Tan Suppe',
          allergene: '(A, F)',
          preis: '3,30 €',
        },
        {
          nummer: 5,
          speise: 'Hühnersuppe',
          allergene: '(A, F)',
          preis: '3,30 €',
        },
        {
          nummer: 6,
          speise: 'Eierblumensuppe',
          allergene: '(A, C, F)',
          preis: '3,20 €',
        },
        {
          nummer: 7,
          speise: 'Nudelsuppe',
          allergene: '(A, F)',
          preis: '3,20 €',
        },
        {
          nummer: 8,
          speise: 'Süß-Sauer-Scharf Suppe',
          allergene: '(A, F)',
          preis: '3,20 €',
        },
        {
          nummer: 9,
          speise: 'Tong Yam Gong Suppe',
          anzahl: '',
          allergene: '(A, F)',
          preis: '5,20 €',
        },
      ],
    };
  },
    methods: {
    top() {
      window.scrollTo(0,0);
    }
  },
  created () {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
